/**
 * useScoringRuns — GET /v1/admin/scoring-runs
 *
 * Powers the admin scoring-run audit page. Filterable by performance year.
 * Invalidated whenever `useRecompute` mutates (a recompute creates a new
 * scoring run row).
 */
import { useQuery } from "@tanstack/react-query";
import { getApiClient } from "@/api/client";
import type { ScoringRunListResponse } from "@/api/models";
import { queryKeys } from "./queryKeys";

export function useScoringRuns(year?: number) {
  return useQuery({
    queryKey: queryKeys.scoringRuns.list(year),
    queryFn: async (): Promise<ScoringRunListResponse> => {
      const { data } = await getApiClient().get<ScoringRunListResponse>(
        "/v1/admin/scoring-runs",
        {
          params: year !== undefined ? { performance_year: year } : undefined,
        },
      );
      return data;
    },
    staleTime: 30_000,
  });
}
